module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": "",
      "ma-0": "",
      "pa-0": ""
    }
  }, [
    [(_vm.intencaoVaga.intencao) ? _c('div', [_c('h4', {
      staticClass: "title mb-3"
    }, [_vm._v("Intenção de vaga:")]), _vm._v(" "), _c('v-alert', {
      attrs: {
        "value": true,
        "type": "warning"
      }
    }, [_vm._l((_vm.intencaoVaga.mensagem), function(mensagem) {
      return [_vm._v(_vm._s(mensagem)), _c('br')]
    })], 2)], 1) : (_vm.incentivos.length) ? _c('div', [_c('h4', {
      staticClass: "title mb-3"
    }, [_vm._v("Você possui incentivos ativos:")]), _vm._v(" "), _c('v-alert', {
      attrs: {
        "value": true,
        "type": "info"
      }
    }, [_vm._l((_vm.incentivos), function(item) {
      return [_vm._v("\n            " + _vm._s(item)), _c('br')]
    }), _vm._v("\n          ATENÇÃO: Caso não concorde com os valores impressos, não conclua sua pré-matrícula e entre em contato com a Central de Atendimento.\n        ")], 2)], 1) : _c('div', [_c('v-alert', {
      attrs: {
        "value": true,
        "type": "warning"
      }
    }, [_vm._v("\n          Você não possui incentivos (FIES, PROUNI, etc). Caso não concorde, não conclua sua pré-matrícula e entre em contato com a Central de Atendimento.\n        ")])], 1)], _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('h4', {
      staticClass: "title mb-3"
    }, [_vm._v("Formas de pagamento:")]), _vm._v(" "), _c('v-radio-group', {
      model: {
        value: (_vm.dadosMatricula.matricula.parcelamento),
        callback: function($$v) {
          _vm.$set(_vm.dadosMatricula.matricula, "parcelamento", $$v)
        },
        expression: "dadosMatricula.matricula.parcelamento"
      }
    }, _vm._l((_vm.parcelasDisponiveis), function(item, index) {
      return _c('v-radio', {
        key: index,
        attrs: {
          "value": item.quantidade
        }
      }, [(item.quantidade > 1) ? _c('template', {
        slot: "label"
      }, [_vm._l((item.detalhes), function(parcela) {
        return [(parcela.numeroParcela == 1) ? _c('span', [_c('strong', [_vm._v(_vm._s(parcela.numeroParcela) + "x")]), _vm._v(" de R$ " + _vm._s(_vm._f("currencyEnToBr")(parcela.valorUnitario)) + " + "), _c('strong', [_vm._v(_vm._s(item.quantidade - 1) + "x")]), _vm._v(" de R$ " + _vm._s(_vm._f("currencyEnToBr")(item.valor)) + "\n                    ")]) : _vm._e()]
      })], 2) : _vm._e(), _vm._v(" "), (item.quantidade == 1) ? _c('template', {
        slot: "label"
      }, [_c('strong', [_vm._v(_vm._s(item.quantidade) + "x")]), _vm._v(" de R$ " + _vm._s(_vm._f("currencyEnToBr")(item.valor)) + "\n                  "), (item.textoAdicional) ? _c('span', [_vm._v(" (" + _vm._s(item.textoAdicional) + ")")]) : _vm._e(), _vm._v(" "), (item.quantidade === 1 && !_vm.intencaoVaga.intencao) ? _c('span', [_vm._v(" (com desconto de antecipação de " + _vm._s(_vm.descontoAVista) + "%)")]) : _vm._e()]) : _vm._e()], 2)
    }), 1), _vm._v(" "), _c('h4', {
      staticClass: "title mt-4 mb-3"
    }, [_vm._v("Dados dos Pagamentos")]), _vm._v(" "), (_vm.parcelaSelecionada) ? _c('table', {
      staticClass: "v-datatable v-table theme--light"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Parcela")]), _vm._v(" "), _c('th', [_vm._v("Data de Vencimento")]), _vm._v(" "), _c('th', [_vm._v("Valor")]), _vm._v(" "), _c('th', [_vm._v("Valor Sem Descontos")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.parcelaSelecionada.detalhes), function(parcelas, indice) {
      return _c('tr', {
        key: indice
      }, [_c('td', [_vm._v(_vm._s(indice + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateEnToBr")(parcelas.dataVencimento)))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("currencyEnToBr")(parcelas.valorUnitario)))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("currencyEnToBr")(parcelas.valorSemDesconto)))])])
    }), 0)]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "flex-header"
    }, [_c('navigation-buttons', {
      attrs: {
        "show-previous": true,
        "show-next": true,
        "disable-next": _vm.$v.dadosMatricula.$invalid,
        "previous-click": _vm.voltar,
        "next-click": _vm.salvarDados
      }
    })], 1)
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e118e98!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/dashboard/matricula_online/Financeiro.vue
// module id = 540
// module chunks = 2